import React from 'react';
import {useField, useFormikContext} from 'formik';

import {Column} from '../layout';
import ErrorMessage from './ErrorMessage';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import './styles.scss';
import AppRadioSelectInput from '../input/app-radio-select-input';
import {Option} from '../input/app-radio-select-input/AppRadioSelectInput';

interface AppFormRadioFieldFieldProps
  extends React.HTMLProps<HTMLInputElement> {
  name: string;
  className: string;
  options: Option[];
  showErrorMessage?: boolean;
}

function AppFormRadioFieldField({
  options,
  name,
  className,
  showErrorMessage = false,
}: AppFormRadioFieldFieldProps) {
  const {setFieldTouched, errors, touched, setFieldValue} = useFormikContext();
  const error = (errors as any)[name];
  const visible = (touched as any)[name];

  const [field] = useField(name);

  return (
    <Column>
      <AppRadioSelectInput
        value={field.value}
        options={options}
        onChange={(value) => setFieldValue(name, value)}
        onBlur={() => setFieldTouched(name)}
        className={className}
      />
      {error && visible && (
        <Icon
          width="24"
          height="24"
          className="app-form-field-error app-form-field-error-date"
          name={Icons.ALERT_PROBLEM}
          color={colors.alertRed}
        />
      )}
      {showErrorMessage && <ErrorMessage error={error} visible={visible} />}
    </Column>
  );
}

export default AppFormRadioFieldField;
